import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";


// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCNP8AVk_wuPyPJiNvIV_SdczMw9gGqek4",
  authDomain: "linkedin-clone-b6a24.firebaseapp.com",
  projectId: "linkedin-clone-b6a24",
  storageBucket: "linkedin-clone-b6a24.appspot.com",
  messagingSenderId: "796040282535",
  appId: "1:796040282535:web:7650b28f231a99b655b682",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore(); /*connect to db */
const auth = firebase.auth(); /*authentication */
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage(); /*store images */

export { auth, provider, storage, firebaseApp, db };
